export default __webpack_public_path__ + "static/media/email-input-field-button.ec90420f.svg";